import {
  ITimezone,
  useGetLanguagesQuery,
  useGetTimeZonesQuery,
} from 'app/services/constants';
import { createContext, ReactNode, useContext } from 'react';

const context = createContext<{
  timezones: ITimezone[];

  languages: { id: number; name: string }[];
}>({ timezones: [], languages: [] });

export default function ContantsProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { data: timezones } = useGetTimeZonesQuery();

  const { data: languages } = useGetLanguagesQuery();

  return (
    <context.Provider
      value={{ timezones: timezones || [], languages: languages || [] }}
    >
      {children}
    </context.Provider>
  );
}

export const useTimezones = () => useContext(context).timezones;

export const useLanguages = () => useContext(context).languages;
